import React from "react";
import { BloombergLogoSmall, WeekendLogo } from "@bloomberg/media-ui-icons";

import { Story, getWeekendCollection } from "~types/types";

import styles from "./WeekendRedirectTout.module.css";

interface WeekendRedirectToutProps {
    story: Story;
}

const WeekendRedirectTout = ({ story }: WeekendRedirectToutProps) => {
    const weekendCollection = getWeekendCollection(story);
    const isStoryInLatestWeekendCollection =
        weekendCollection?.slug === story.collections?.weekendId;

    if (isStoryInLatestWeekendCollection) {
        console.error(
            "<WeekendRedirectTout /> only renders on a story that is part of a completed weekend collection"
        );
        return null;
    }

    return (
        <div
            className={styles.weekendRedirectTout}
            data-component="weekend-redirect-tout"
        >
            <a href="/weekend">
                <div className={styles.bloombergLogo}>
                    <BloombergLogoSmall />
                </div>
                <WeekendLogo className={styles.logo} />
            </a>
            <div className={styles.description}>
                {`This story was featured in
                Bloomberg's Weekend section. `}
                <div>
                    <a href="/weekend" className={styles.link}>
                        Read More Here
                    </a>
                </div>
            </div>
        </div>
    );
};

export default WeekendRedirectTout;
